import React, { useEffect, useState } from "react";
import imgDoctor from "../assets/bundit_l.png";
import imgMaster from "../assets/bundit_ll.png";
import axios from "axios";
import { Button, MoreIcon, Pane, Text } from "evergreen-ui";
import { FaHandPointUp } from "react-icons/fa";
import { MdFiberNew } from "react-icons/md";
function Select_bundit() {
  const [News, setNews] = useState([]);
  const [Slice1, setSlice] = useState(0);
  const [Slice2, setSlice2] = useState(3);
  const DateFormat = (val) => {
    const date = new Date(val);
    const thaiLocale = "th-TH";
    const options = {
      weekday: "long", // แสดงวันในรูปแบบ "วันจันทร์" หรือ "Monday"
      year: "numeric",
      month: "short", // แสดงเดือนในรูปแบบ "มกราคม" หรือ "January"
      day: "numeric",
    };
    const thaiDateString = date.toLocaleDateString(thaiLocale, options);
    return thaiDateString;
  };
  const Start = (params) => {
    axios.get("https://admission.kpru.ac.th/admission2017/administrator_new/show/3").then((res) => {
      const data = res.data;
      if (data.length !== 0) {
        console.log(data);
        setNews(res.data);
      } else {
        setNews([]);
      }
    });
  };
  useEffect(() => {
    Start();
    Checkdate();
  }, []);
  const Checkdate = () => {
    const now = new Date();
    const target = new Date("2025-10-25T23:59:00");
    const targetstart = new Date("2025-08-27T23:59:00");

    if (now > target) {
      // console.log("ปิด");
      return 0; // หลังวันที่กำหนด
    } else {
      if (now < targetstart) {
        return 0; // ก่อนหรือเท่ากับวันที่กำหนด
      } else {
        return 1; // ก่อนหรือเท่ากับวันที่กำหนด
      }
      // console.log("เปิด");
    }
  };

  return (
    <div className="container mt-4">
      <div className="text-center my-4" style={{ fontSize: "20px", fontWeight: "500" }}>
        เลือกรายการที่ต้องการ
      </div>
      <div
        className="d-flex flex-md-row flex-column justify-content-center align-items-center"
        style={{ gap: "100px" }}
      >
        <div className="imgBundit_2">
          <div>
            <img
              src={imgMaster}
              alt=""
              style={{ borderRadius: "10px", opacity:"1"}}
              onClick={() => {
                // if (Checkdate() === 1) {
                // }
                window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Formregister-bundit`;
                localStorage.setItem("typestudent", "3");
              }}
            />{" "}
          </div>
        </div>

        <div className="imgBundit_1">
          <div>
            <img
              src={imgDoctor}
              alt=""
              style={{ borderRadius: "10px", opacity: "1" }}
              onClick={() => {
                window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Formregister-bundit`;
                localStorage.setItem("typestudent", "4");
              }}
            />{" "}
          </div>
        </div>
      </div>
      <Pane className="p-2 mt-4 container-fluid">
        <div style={{ fontSize: "clamp(12px ,4rem,18px)" }}>ข่าวประชาสัมพันธ์</div>
        <Pane className="d-flex flex-wrap mt-3  blinking-text" gap={10}>
          {Array.isArray(News) &&
            News.slice(Slice1, Slice2).map((i, key) => (
              <Pane
                boxShadow="0px 0px 10px #00000030"
                className="bg-white p-2 px-3 col-12 d-flex flex-row"
              >
                <div className="col">
                  {key === 0 ? (
                    <blink>
                      <MdFiberNew color="red" size={20} />
                    </blink>
                  ) : (
                    ""
                  )}
                  <div className="d-flex flex-column">
                    <Text>{i.NEWS_TITEL}</Text>
                    <Text className="text-primary ">
                      ประกาศ ณ {DateFormat(i.NEWS_DATE)} &nbsp;{" "}
                    </Text>
                  </div>
                </div>

                {/* <blink>อ่านต่อ</blink> */}
                <div className="col-2 m-0 d-flex justify-content-end align-items-center">
                  {" "}
                  <Button
                    onClick={() => {
                      window.open(i.NEWS_FILE);
                    }}
                    iconAfter={<FaHandPointUp />}
                    size="small"
                    appearance="minimal"
                    color="orange"
                  >
                    อ่านต่อ
                  </Button>
                </div>
              </Pane>
            ))}
          <Pane className="d-flex justify-content-end col-12">
            <Button
              iconBefore={<MoreIcon />}
              appearance="primary"
              onClick={() => {
                setSlice2(Slice2 !== 3 ? 3 : News.length);
              }}
            >
              {Slice2 === 3 ? "ดูเพิ่มเติม" : "น้อยลง"}
            </Button>
          </Pane>
        </Pane>
      </Pane>
    </div>
  );
}

export default Select_bundit;


